import dayjs from "dayjs";
import Typography from "@mui/material/Typography";
import { CalendarIcon } from "lucide-react";

const ExpirationChip = ({ date }) => {
  if (!date) return null;

  const today = dayjs();
  const expirationDate = dayjs(date, "DD-MM-YYYY");
  const sevenDaysBefore = today.add(7, "day");

  let backgroundColor, textColor;
  if (expirationDate.isBefore(today)) {
    backgroundColor = "red";
    textColor = "white";
  } else if (expirationDate.isBefore(sevenDaysBefore)) {
    backgroundColor = "#ff9407";
    textColor = "black";
  } else {
    backgroundColor = "#28a745";
    textColor = "black";
  }

  return (
    <Typography
      variant="caption"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        padding: "4px 8px",
        borderRadius: "16px",
        backgroundColor: backgroundColor,
        color: textColor,
        boxShadow: (theme) => `0 1px 3px ${theme.palette.action.active}`,
        fontWeight: 600,
        fontSize: "14px",
      }}
    >
      {date}
    </Typography>
  );
};

export default ExpirationChip;